<template>
  <div class="LongTimeField">
    <div class="label">{{ label }}</div>
    <div class="value" @click="onConfirm">
      <img v-if="switchOn" src="@/assets/style/switch-open.png" alt="">
      <img v-else src="@/assets/style/switch-on.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "LongTimeField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      switchOn: false,
      showDatePicker: false,
      currentDate: new Date(),
    };
  },
  async mounted() {},
  methods: {
    onConfirm() {
      this.switchOn = !this.switchOn;
      this.$emit("input", this.switchOn);
    },
  },
  watch: {
    value(newVal) {
      this.switchOn = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.LongTimeField {
  padding: 10px;
  font-size: 14px;
  color: #333333;
  background: #F9F9F9;
  border-radius: 27px;
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.label {
  font-size: 14px;
  color: #777777;
  width: 70px;
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  border-radius: 17px;
  justify-content: flex-end;
  img{
    height: 24px;
  }
}
</style>
